var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTimeIcon = function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#time-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#time-icon_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M60 89.62c20.553 0 37.215-16.662 37.215-37.215S80.553 15.19 60 15.19 22.785 31.852 22.785 52.405 39.447 89.62 60 89.62"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    d: "M60 89.24c20.344 0 36.835-16.491 36.835-36.835S80.344 15.57 60 15.57 23.165 32.06 23.165 52.405 39.656 89.24 60 89.24Z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#time-icon_svg__c)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M60 52.405a7.975 7.975 0 0 0-7.975 7.975v2.658a1.33 1.33 0 0 0 1.33 1.329h13.29a1.33 1.33 0 0 0 1.33-1.33V60.38A7.974 7.974 0 0 0 60 52.405m0 0a7.974 7.974 0 0 1-7.975-7.975v-2.658a1.33 1.33 0 0 1 1.33-1.329h13.29a1.33 1.33 0 0 1 1.33 1.33v2.657A7.974 7.974 0 0 1 60 52.405"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "time-icon_svg__c",
    x1: 67.975,
    x2: 45.728,
    y1: 64.367,
    y2: 54.137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB132"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F15A22"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "time-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "time-icon_svg__b",
    width: 134.671,
    height: 134.671,
    x: -7.335,
    y: -4.93,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_158_139"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_158_139",
    result: "shape"
  })))));
};
export default SvgTimeIcon;